export enum EGizmo {
  None,
  ShareTheWealth,
  DoubleDown,
  OnTheHouse
}